import React from 'react';
import Stack from '@mui/joy/Stack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Loader: React.FC = () => (
	<Stack sx={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
		<FontAwesomeIcon icon={['fad', 'loader']} size="lg" spin />
	</Stack>
);

export default Loader;
